import React from "react";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import Grid from "@material-ui/core/Grid";
import { observer } from "mobx-react-lite";
import { StyledTableCell, useStyles } from "../Tables.styles";
import { TableBodySkeleton } from "../../../components/Skeletons/Tables/TableBody/TableBody";
import { TableFooterPagination } from "../TableFooterPagination/TableFooterPagination";
import { tableStore } from "../../../mobx/stores/TableStore/TableStore";
import { StudentsProfilesTableRow } from "./StudentsProfilesTableRow/StudentsProfilesTableRow";

interface StudentsProfilesTableProps {
  loading: boolean;
}

export const StudentsProfilesTable = observer(({ loading }: StudentsProfilesTableProps) => {
  const classes = useStyles();
  const { page, users } = tableStore;
  const { per_page } = page;
  const usersInfo = Object.values(users)
    .filter((x) => !x.deleted_at)
    .slice(0, per_page);

  return (
    <Grid item xs={12}>
      <Paper className={classes.paper}>
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <StyledTableCell width={20}>Id</StyledTableCell>
                <StyledTableCell>Имя</StyledTableCell>
                <StyledTableCell>Роль</StyledTableCell>
                <StyledTableCell>Дата создания</StyledTableCell>
                <StyledTableCell>Дата Обновления</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            {loading ? (
              <TableBodySkeleton cols={6} rows={per_page} />
            ) : (
              <TableBody>
                {usersInfo.map((user) => (
                  <StudentsProfilesTableRow user={user} key={user.id} />
                ))}
              </TableBody>
            )}
            <TableFooterPagination colSpan={6} />
          </Table>
        </TableContainer>
      </Paper>
    </Grid>
  );
});
